import { flow, get, pickBy, keys, map } from 'lodash/fp';
import closeEstimate from './closeEstimate';

const clearDesignsWhere = predicate => (
  (dispatch, getState) => {
    const designsToRemove = flow(
      get('estimateBuilder.entities.estimates.byId'),
      pickBy(predicate),
      keys,
      map(closeEstimate),
      map(dispatch),
    )(getState());

    return Promise.all(designsToRemove);
  }
);
export default clearDesignsWhere;
